import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

const $ = jQuery.noConflict();
export class ZIDXAccountLeadView implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountLeadViewContainer";
    }
    render(){
        // clicking the Call link (tel:) also prepares the log call form for an outbound call
        let self=this;
        $(".zidxAccountLeadViewContainer .zidxCallPhoneLink", this.zidx.peakidxShadowRoot).on("click", function() {
            let form=$(".zidxAccountLeadViewContainer #zidxLogCallForm", self.zidx.peakidxShadowRoot);
            form.find("[name=call_log_direction]").val("outbound");
            form.find("[name=call_log_outcome]").trigger("focus");
        });
    }
}
